/** In percent. 100 is the frame as it is. */
export type ImageAdjustments = { brightness: number; contrast: number };

export const DEFAULT_IMAGE_ADJUSTMENTS: ImageAdjustments = {
  brightness: 100,
  contrast: 100,
};

// The same range for both, so at 100% their sliders' thumbs line up.
export const BRIGHTNESS_RANGE = { min: 50, max: 200, step: 5 };
export const CONTRAST_RANGE = { min: 50, max: 200, step: 5 };

export const isAdjusted = ({ brightness, contrast }: ImageAdjustments) =>
  brightness !== 100 || contrast !== 100;

/** The CSS filter for the frame. None when the frame hasn't been adjusted. */
export const imageAdjustmentsFilter = (
  adjustments: ImageAdjustments,
): string | undefined => {
  if (!isAdjusted(adjustments)) {
    return undefined;
  }

  return `brightness(${adjustments.brightness / 100}) contrast(${adjustments.contrast / 100})`;
};
